// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"1a6b7b9a","361":"49147445","673":"446858ce"}[chunkId] + ".chunk.js";
};